module.exports = __webpack_public_path__ + "img/red-square.c9d1229e.png";